module.exports = __webpack_public_path__ + "img/git-branch-02.3e966e38.svg";